export default "__VITE_ASSET__COiLCC_C__"